import React from 'react';
import { motion } from 'framer-motion';

const metrics = [
  { label: 'DB Load Reduction', value: '60%' },
  { label: 'Years Experience', value: '11+' },
  { label: 'Production Platforms', value: '10+' },
  { label: 'Core Focus', value: 'Scalability' },
];

const ImpactMetricsV3 = () => {
  return (
    <section className="w-full rounded-2xl bg-gray-50 border border-gray-200">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <h2 className="text-4xl font-bold tracking-tight text-gray-900 mb-8">Impact Metrics</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {metrics.map((metric, i) => (
            <motion.div
              key={metric.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              viewport={{ once: true }}
              className="rounded-xl bg-white p-6 text-center shadow-md hover:shadow-lg hover:-translate-y-2 transition-all duration-300"
            >
              <p className="text-3xl font-bold text-blue-600">{metric.value}</p>
              <p className="text-sm text-gray-600 mt-2">{metric.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactMetricsV3;
